import React from 'react';
import { CreditCard, QrCode } from 'lucide-react';
import type { PaymentMethod } from '../api/billing';

/** Card / Halyk QR pill selector, shared between PlansPage and ProfilePage. */
export default function PaymentMethodToggle({
  value, onChange, t,
}: {
  value: PaymentMethod;
  onChange: (v: PaymentMethod) => void;
  t: (k: string) => string;
}) {
  return (
    <div className="inline-flex items-center bg-slate-100 rounded-xl p-1 gap-1 flex-shrink-0">
      <button
        type="button"
        onClick={() => onChange('card')}
        className={`flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-xs font-bold transition-colors ${
          value === 'card' ? 'bg-white text-goszakup-700 shadow-sm' : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        <CreditCard className="w-3.5 h-3.5" /> {t('plans.methodCard')}
      </button>
      <button
        type="button"
        onClick={() => onChange('qr')}
        className={`flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-xs font-bold transition-colors ${
          value === 'qr' ? 'bg-white text-goszakup-700 shadow-sm' : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        <QrCode className="w-3.5 h-3.5" /> {t('plans.methodQr')}
      </button>
    </div>
  );
}
